
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import ClientInformationSection from "@/components/programs/review/ClientInformationSection";
import ProgramDetailsSection from "@/components/programs/review/ProgramDetailsSection";
import TierSpecificSection from "@/components/programs/review/TierSpecificSection";
import PreferencesSection from "@/components/programs/review/PreferencesSection";
import { ProgramStructureSection } from "@/components/programs/detail/ProgramStructureSection";

interface ProgramDetailContentProps {
  program: any;
  programData?: any;
}

export function ProgramDetailContent({ program, programData }: ProgramDetailContentProps) {
  // Merge the program data from both sources
  const mergedProgramData = {
    ...program.program_data || {},
    ...programData || {}
  };
  
  const tierQuestions = program.tier_questions || {};
  const aiContext = program.ai_context || {};
  const preferences = mergedProgramData.preferences || {};
  const tier = mergedProgramData.tier || program.tier || 'Beginner';
  
  // For debugging
  console.log("Program Data in ProgramDetailContent:", mergedProgramData);
  console.log("Program Data additional:", programData);
  console.log("AI Context in ProgramDetailContent:", aiContext);
  
  return (
    <ScrollArea className="h-[calc(100vh-220px)]">
      <div className="grid grid-cols-1 gap-6 animate-slide-in pr-4">
        <Card className="backdrop-blur-lg bg-white/10 border-white/20">
          <CardHeader>
            <CardTitle className="text-white">Program Details</CardTitle>
          </CardHeader>
          <CardContent className="space-y-8">
            {/* Program Details */}
            <ProgramDetailsSection 
              programData={mergedProgramData} 
              aiContext={aiContext} 
            />
            
            {/* Client Information */}
            {mergedProgramData.assigned_clients && mergedProgramData.assigned_clients.length > 0 && (
              <ClientInformationSection 
                selectedClient={{
                  id: mergedProgramData.assigned_clients[0].id,
                  name: mergedProgramData.assigned_clients[0].name,
                  avatar: mergedProgramData.assigned_clients[0].avatar
                }} 
              />
            )}
            
            {/* Program Structure - New section to display the program days and exercises */}
            <ProgramStructureSection programData={programData} />
            
            {/* Tier-Specific Information */}
            <TierSpecificSection 
              tier={tier} 
              tierData={tierQuestions} 
              aiContext={aiContext}
            />
            
            {/* Preferences & Customizations */}
            {Object.keys(preferences).length > 0 && (
              <PreferencesSection 
                preferencesData={preferences} 
                aiContext={aiContext?.preferences}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </ScrollArea>
  );
}
